export default "__VITE_ASSET__397edcd5__"